module.exports = __webpack_public_path__ + "img/icon_instagram.cf3e08a3.png";